import { withInstall } from '@zoryn/utils'
import Backtop from './src/backtop.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZBacktop: SFCWithInstall<typeof Backtop> = withInstall(Backtop)
export default ZBacktop

export * from './src/backtop'
export type { BacktopInstance } from './src/instance'
